import { styled } from '@mui/system';
import { Dialog } from '@cw-ui/feedback-components';
import IconButton from '@mui/material/IconButton';

export const DialogTitle = styled(Dialog.Title)(() => ({
    paddingLeft: '16px',
}));

export const Icon = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    right: 8,
    top: 8,
    color: theme.palette.icon.iconPrimary,
}));

export const DialogContent = styled(Dialog.DialogContent)(() => ({
    padding: '0px 16px 0 16px',
    marginBottom: '24px',
}));

export const Actions = styled(Dialog.DialogActions)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    padding: ' 0 16px 16px 16px',
}));
